import React from 'react';
import { Main } from './styles';

export const Footer = () => {
  return (
    <Main>
      <span>© 2025 Virtual Officer -</span>
      <p>Todos Direitos Reservados</p>
    </Main>
  );
};
